import {Dispatch} from "redux";
import {IResponse, RACARequest} from "../../../Request";
import {endLoading, startLoading} from "../../../../store/slices/loadingSlice";
import requestMiddlewares from "../../../requestMiddlewares";
import {GetSelectedCompany} from "../../../../utils/selectCompany";

export interface ISendPackageMessageInput {
  message: string;
  recipient: string;
}

export default async function (
  dispatch: Dispatch,
  id: string,
  data: ISendPackageMessageInput,
): Promise<IResponse> {
  const cid = GetSelectedCompany();
  if (!cid) {
    return {
      statusCode: 500,
      data: {
        message: 'No company selected'
      }
    }
  }
  dispatch(startLoading());

  const request = new RACARequest('companyPackages', 'partialUpdate')
    .setPathValues('COMPANY_ID', cid)
    .setPathValues('ID', id)
    .setData({
      action: 'sendMessage',
      data: data,
    });

  const response = await request.makeRequest();
  requestMiddlewares(
    dispatch,
    response,
  );

  dispatch(endLoading());

  return response;
}
